module.exports = __webpack_public_path__ + "assets/search-land.d427a0c8.svg";